import { Button, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import * as PropTypes from 'prop-types';
import React from 'react';

const useStyles = makeStyles({
  buttonSave: ({ capitalize, cor, width }) => ({
    background: '#fff',
    border: cor ? `1px solid ${cor}` : '1px solid #5890aa',
    color: cor ? cor : '#5890aa',
    height: 36,
    marginLeft: 10,
    borderRadius: 5,
    fontSize: 14,
    textTransform: capitalize ? 'capitalize' : 'initial',
    width: width ? width : 'auto',
  }),
});

const AddButton = ({ children, onClick, disabled, endIcon, capitalize = true, cor, width }) => {
  const classes = useStyles({ capitalize, cor, width });
  return (
    <Button className={classes.buttonSave} onClick={onClick} disabled={disabled} endIcon={endIcon}>
      <Typography style={{ margin: 0 }}>{children}</Typography>
    </Button>
  );
};
AddButton.propTypes = {
  onClick: PropTypes.func,
  children: PropTypes.node,
  disabled: PropTypes.bool,
};

AddButton.defaultProps = {};

export default AddButton;
